import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10560dec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "indexlayout-main-conent" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-border-bottom" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "h2-blue-underline" }, "包裹信息")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-border-bottom" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "h2-blue-underline" }, "SKU信息")
], -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "包裹总重量最大值为15kg", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "汇率换算后申报价值请控制在0.01～150欧元之间", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1、包裹长度最大值在150cm以内", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2、包裹尺寸范围限制：长+(宽+高)x2≤300cm", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1、包裹长度最大值在150cm以内", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2、包裹尺寸范围限制：长+(宽+高)x2≤300cm", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1、包裹长度最大值在150cm以内", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2、包裹尺寸范围限制：长+(宽+高)x2≤300cm", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-border-bottom" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "h2-blue-underline" }, "收件人信息"),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#0f74cb","margin-left":"30px","margin-top":"2px"} }, " * 温馨提示:您填写的收件人信息根据实际派送服务商的要求进行校验 ")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "姓名长度限制为1～40个字符", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "省/州长度限制为1～40个字符", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "城市长度限制为1～40个字符", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "邮编长度限制为1～8位字符", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "收件人地址1+收件人地址2的输入长度限制在3～96个字符之间", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "收件人地址1+收件人地址2的输入长度限制在3～96个字符之间", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-border-bottom",
  style: {"justify-content":"flex-start","margin-top":"10px"}
}, [
  /*#__PURE__*/_createElementVNode("h2", { class: "h2-blue-underline" }, "发件人信息"),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#0f74cb","margin-left":"30px","margin-top":"2px"} }, " * 温馨提示：发货地址用于标签打印、出口报关申报、进口清关申报，需填写英文信息。 ")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-border-bottom",
  style: {"margin-top":"20px"}
}, [
  /*#__PURE__*/_createElementVNode("h2", { class: "h2-blue-underline" }, "揽收地址信息"),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#0f74cb","margin-left":"30px","margin-top":"2px"} }, " * 温馨提示：揽收地址用于货物揽收，需填写中文信息。 ")
], -1))
const _hoisted_23 = { style: {"display":"flex","flex":"1","justify-content":"center"} }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { key: 3 }
const _hoisted_28 = { key: 4 }
const _hoisted_29 = { key: 5 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_info_circle_outlined = _resolveComponent("info-circle-outlined")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_Address = _resolveComponent("Address")!
  const _component_Addsku = _resolveComponent("Addsku")!
  const _component_NewlyAddedSku = _resolveComponent("NewlyAddedSku")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isBoolean)
      ? (_openBlock(), _createBlock(_component_a_card, { key: 0 }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createVNode(_component_a_form, { selfUpdate: true }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, { gutter: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "目的国",
                          labelCol: {span:6},
                          wrapperCol: {span: 18}
                        }, _ctx.validateInfos.destination), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              allowClear: "",
                              "show-search": "",
                              getPopupContainer: (triggerNode)=>triggerNode.parentNode,
                              "filter-option": _ctx.filterOption,
                              placeholder: "请选择目的国",
                              onChange: _ctx.handleDestination,
                              onSelect: _ctx.handleSelectDes,
                              value: _ctx.modelRef.destination,
                              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelRef.destination) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countrylistSet, (item) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: item.code,
                                    value: item.name
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["getPopupContainer", "filter-option", "onChange", "onSelect", "value"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "产品类别",
                          labelCol: {span:6},
                          wrapperCol: {span: 18}
                        }, _ctx.validateInfos.productType), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              placeholder: "请选择产品类别",
                              value: _ctx.modelRef.productType,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelRef.productType) = $event)),
                              allowClear: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("标准")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "商品属性",
                          labelCol: {span:6},
                          wrapperCol: {span: 18}
                        }, _ctx.validateInfos.hasBattery), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              placeholder: "商品属性",
                              value: _ctx.modelRef.hasBattery,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelRef.hasBattery) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: 0 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("普货")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, { gutter: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "贸易方式",
                          labelCol: {span:6},
                          wrapperCol: {span: 18}
                        }, _ctx.validateInfos.tradeWay), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              placeholder: "贸易方式",
                              value: _ctx.modelRef.tradeWay,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelRef.tradeWay) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: 'DDP' }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("DDP")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "IOSS",
                          labelCol: {span:6},
                          wrapperCol: {span: 18}
                        }, _ctx.validateInfos.vatIoss), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              placeholder: "请输入IOSS",
                              value: _ctx.modelRef.vatIoss,
                              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelRef.vatIoss) = $event)),
                              onChange: _ctx.handleStore
                            }, null, 8, ["value", "onChange"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "交易单号",
                          labelCol: {span:6},
                          wrapperCol: {span: 18}
                        }, _ctx.validateInfos.transactionNo), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.modelRef.transactionNo,
                              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modelRef.transactionNo) = $event)),
                              placeholder: "请输入交易单号"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _hoisted_3,
                _createVNode(_component_a_row, {
                  justify: "end",
                  style: {"margin-bottom":"10px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleModal('addSku')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("为您的包裹添加sku信息")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_table, {
                      style: {"width":"100%"},
                      rowKey: "id",
                      columns: _ctx.columns,
                      dataSource: _ctx.skuList,
                      loading: _ctx.loading,
                      scroll: {x:'calc(100vw + 30%)'},
                      size: "small"
                    }, {
                      bodyCell: _withCtx(({column,text,record}) => [
                        (column.dataIndex === 'declareNumber')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (record.isflag)
                                ? (_openBlock(), _createBlock(_component_a_input_number, {
                                    key: 0,
                                    id: "inputNumber",
                                    value: record.declareNumber,
                                    "onUpdate:value": ($event: any) => ((record.declareNumber) = $event),
                                    min: 1,
                                    precision: 0,
                                    onBlur: _ctx.handleChangeNumber
                                  }, null, 8, ["value", "onUpdate:value", "onBlur"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(text), 1))
                            ], 64))
                          : _createCommentVNode("", true),
                        (column.dataIndex === 'dHeight')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(`${record.length}*${record.width}*${record.height}`), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (column.dataIndex === 'rHeight')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createTextVNode(_toDisplayString(record.realLength +'*' + record.realWidth +'*'+ record.realHeight), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (column.dataIndex === 'hasBattery')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createTextVNode(_toDisplayString(_ctx.changeTxt(text,'hasBattery')), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (column.dataIndex === 'action')
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 4,
                              onClick: ($event: any) => (_ctx.handleModal('delete',record))
                            }, "删除", 8, _hoisted_5))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["columns", "dataSource", "loading", "scroll"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, {
                  gutter: 24,
                  style: {"margin-top":"20px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "包裹总重量",
                          labelCol: {span:6},
                          wrapperCol: {span: 18}
                        }, _ctx.validateInfos.orderWeight), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              type: "number",
                              oninput: "value=value.replace(/[^\\d]/g,'')",
                              value: _ctx.modelRef.orderWeight,
                              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modelRef.orderWeight) = $event)),
                              "addon-after": "g",
                              placeholder: "请输入",
                              style: {"width":"80%"},
                              onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleCheckMsg('orderWeight')))
                            }, null, 8, ["value"]),
                            _createVNode(_component_a_popover, { placement: "topLeft" }, {
                              content: _withCtx(() => [
                                _hoisted_6
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_info_circle_outlined)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "包裹总申报价值",
                          labelCol: {span:6},
                          wrapperCol: {span: 18}
                        }, _ctx.validateInfos.amount), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_row, { gutter: 10 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_col, { span: 11 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_input, {
                                      type: "number",
                                      oninput: "value=value.replace(/[^\\d.]/g,'')",
                                      value: _ctx.modelRef.amount,
                                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modelRef.amount) = $event)),
                                      placeholder: "请输入",
                                      onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleCheckMsg('amount')))
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_col, { span: 8 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, _mergeProps(_ctx.validateInfos.amountCurrency, { style: {"margin-bottom":"0"} }), {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_select, {
                                          value: _ctx.modelRef.amountCurrency,
                                          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modelRef.amountCurrency) = $event))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_select_option, { value: "CNY" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("CNY")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_a_select_option, { value: "USD" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("USD")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_a_select_option, { value: "EUR" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("EUR")
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["value"])
                                      ]),
                                      _: 1
                                    }, 16)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_col, { span: 4 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_popover, { placement: "topLeft" }, {
                                      content: _withCtx(() => [
                                        _hoisted_7
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_info_circle_outlined)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, { gutter: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "包裹长度",
                          labelCol: {span:6},
                          wrapperCol: {span: 18}
                        }, _ctx.validateInfos.length), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              type: "number",
                              oninput: "value=value.replace(/[^\\d]/g,'')",
                              "addon-after": "cm",
                              value: _ctx.modelRef.length,
                              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.modelRef.length) = $event)),
                              placeholder: "请输入",
                              style: {"width":"80%"},
                              onBlur: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleCheckMsg('length')))
                            }, null, 8, ["value"]),
                            _createVNode(_component_a_popover, { placement: "topLeft" }, {
                              content: _withCtx(() => [
                                _hoisted_8,
                                _hoisted_9
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_info_circle_outlined)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "包裹宽度",
                          labelCol: {span:6},
                          wrapperCol: {span: 18}
                        }, _ctx.validateInfos.width), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              type: "number",
                              oninput: "value=value.replace(/[^\\d]/g,'')",
                              "addon-after": "cm",
                              value: _ctx.modelRef.width,
                              "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.modelRef.width) = $event)),
                              placeholder: "请输入",
                              style: {"width":"80%"},
                              onBlur: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleCheckMsg('width')))
                            }, null, 8, ["value"]),
                            _createVNode(_component_a_popover, { placement: "topLeft" }, {
                              content: _withCtx(() => [
                                _hoisted_10,
                                _hoisted_11
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_info_circle_outlined)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "包裹高度",
                          labelCol: {span:6},
                          wrapperCol: {span: 18}
                        }, _ctx.validateInfos.height), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              type: "number",
                              oninput: "value=value.replace(/[^\\d]/g,'')",
                              "addon-after": "cm",
                              value: _ctx.modelRef.height,
                              "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.modelRef.height) = $event)),
                              placeholder: "请输入",
                              style: {"width":"80%"},
                              onBlur: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleCheckMsg('height')))
                            }, null, 8, ["value"]),
                            _createVNode(_component_a_popover, { placement: "topLeft" }, {
                              content: _withCtx(() => [
                                _hoisted_12,
                                _hoisted_13
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_info_circle_outlined)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _hoisted_14,
                _createVNode(_component_a_row, { gutter: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "姓名",
                          labelCol: {span:6},
                          wrapperCol: {span: 18}
                        }, _ctx.validateInfos.userName), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              placeholder: "请输入",
                              value: _ctx.modelRef.userName,
                              "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.modelRef.userName) = $event)),
                              "show-count": "",
                              maxlength: 40,
                              style: {"width":"80%"}
                            }, null, 8, ["value"]),
                            _createVNode(_component_a_popover, { placement: "topLeft" }, {
                              content: _withCtx(() => [
                                _hoisted_15
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_info_circle_outlined)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "电话",
                          labelCol: {span:6},
                          wrapperCol: {span: 18}
                        }, _ctx.validateInfos.mobilePhone), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              placeholder: "请输入",
                              value: _ctx.modelRef.mobilePhone,
                              "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.modelRef.mobilePhone) = $event)),
                              style: {"width":"80%"}
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "电子邮箱",
                          labelCol: {span:6},
                          wrapperCol: {span: 18}
                        }, _ctx.validateInfos.email), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.modelRef.email,
                              "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.modelRef.email) = $event)),
                              style: {"width":"80%"}
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, { gutter: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "国家",
                          labelCol: {span:6},
                          wrapperCol: {span: 18}
                        }, _ctx.validateInfos.countryEn), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              style: {"width":"80%"},
                              disabled: "",
                              getPopupContainer: (triggerNode)=>triggerNode.parentNode,
                              value: _ctx.modelRef.countryEn,
                              "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.modelRef.countryEn) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countrylist, (item) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: item.code,
                                    value: item.code
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.nameEn), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["getPopupContainer", "value"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "省/州",
                          labelCol: {span:6},
                          wrapperCol: {span: 18}
                        }, _ctx.validateInfos.province), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              placeholder: "请输入",
                              style: {"width":"80%"},
                              "show-count": "",
                              maxlength: 40,
                              value: _ctx.modelRef.province,
                              "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.modelRef.province) = $event))
                            }, null, 8, ["value"]),
                            _createVNode(_component_a_popover, { placement: "topLeft" }, {
                              content: _withCtx(() => [
                                _hoisted_16
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_info_circle_outlined)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "城市",
                          labelCol: {span:6},
                          wrapperCol: {span: 18}
                        }, _ctx.validateInfos.city), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              placeholder: "请输入",
                              value: _ctx.modelRef.city,
                              "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.modelRef.city) = $event)),
                              "show-count": "",
                              maxlength: 40,
                              style: {"width":"80%"}
                            }, null, 8, ["value"]),
                            _createVNode(_component_a_popover, { placement: "topLeft" }, {
                              content: _withCtx(() => [
                                _hoisted_17
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_info_circle_outlined)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, { gutter: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "邮编",
                          labelCol: {span:6},
                          wrapperCol: {span: 18}
                        }, _ctx.validateInfos.zipCode), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              placeholder: "请输入",
                              "show-count": "",
                              maxlength: 8,
                              value: _ctx.modelRef.zipCode,
                              "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.modelRef.zipCode) = $event)),
                              style: {"width":"80%"}
                            }, null, 8, ["value"]),
                            _createVNode(_component_a_popover, { placement: "topLeft" }, {
                              content: _withCtx(() => [
                                _hoisted_18
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_info_circle_outlined)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, { gutter: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "地址1",
                          labelCol: {span:4},
                          wrapperCol: {span: 18}
                        }, _ctx.validateInfos.detailedAddress1), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_col, { span: 23 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_textarea, {
                                      placeholder: "请输入",
                                      "show-count": "",
                                      minlength: 3,
                                      maxlength: 96,
                                      value: _ctx.modelRef.detailedAddress1,
                                      "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.modelRef.detailedAddress1) = $event))
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_col, { span: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_popover, { placement: "topLeft" }, {
                                      content: _withCtx(() => [
                                        _hoisted_19
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_info_circle_outlined)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({
                          label: "地址2",
                          labelCol: {span:4},
                          wrapperCol: {span: 18}
                        }, _ctx.validateInfos.detailedAddress2), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_col, { span: 23 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_textarea, {
                                      placeholder: "请输入",
                                      "show-count": "",
                                      minlength: 3,
                                      maxlength: 96,
                                      value: _ctx.modelRef.detailedAddress2,
                                      "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.modelRef.detailedAddress2) = $event))
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_col, { span: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_popover, { placement: "topLeft" }, {
                                      content: _withCtx(() => [
                                        _hoisted_20
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_info_circle_outlined)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _hoisted_21,
                _createVNode(_component_a_row, { gutter: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({ label: "选择发件人地址名称" }, _ctx.validateInfos.sendName), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: _ctx.modelRef.sendName,
                              "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.modelRef.sendName) = $event)),
                              getPopupContainer: (triggerNode) => triggerNode.parentNode,
                              onSelect: _ctx.handleChangeSelect
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSelect, (item) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: item.id,
                                    value: item.addressCode
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.addressName), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["value", "getPopupContainer", "onSelect"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, {
                      span: 16,
                      style: {"display":"flex","justify-content":"flex-end"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.handleModal('add')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("新增发件人信息")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_table, {
                  style: {"width":"100%"},
                  rowKey: "id",
                  columns: _ctx.columns1,
                  dataSource: _ctx.list,
                  loading: _ctx.loading,
                  pagination: false,
                  size: "small"
                }, null, 8, ["columns", "dataSource", "loading"]),
                _hoisted_22,
                _createVNode(_component_a_row, { gutter: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, _mergeProps({ label: "选择揽收地址名称" }, _ctx.validateInfos.getName), {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: _ctx.modelRef.getName,
                              "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.modelRef.getName) = $event)),
                              getPopupContainer: (triggerNode) => triggerNode.parentNode,
                              onSelect: _ctx.handleChangeSelect2
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listlSelect, (item) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: item.id,
                                    value: item.addressCode
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.addressName), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["value", "getPopupContainer", "onSelect"])
                          ]),
                          _: 1
                        }, 16)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, {
                      span: 16,
                      style: {"display":"flex","justify-content":"flex-end"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.handleModal('Sender')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("新增揽收地址信息")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_table, {
                  style: {"width":"100%"},
                  rowKey: "id",
                  columns: _ctx.columns2,
                  dataSource: _ctx.listl,
                  loading: _ctx.loadingl,
                  pagination: false,
                  size: "small"
                }, {
                  bodyCell: _withCtx(({column,text}) => [
                    (column.dataIndex === 'deliveryType')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.changeTxt(text,'detype')), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (column.dataIndex === 'pickupCycle')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.changeTxt(text,'cycle')), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (column.dataIndex === 'auditStatus')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(_ctx.changeTxt(text,'auditStatus')), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["columns", "dataSource", "loading"]),
                _createVNode(_component_a_row, {
                  justify: "center",
                  style: {"margin-top":"20px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, { onClick: _ctx.handleBack }, {
                      default: _withCtx(() => [
                        _createTextVNode("返回")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      style: {"margin-left":"10px"},
                      disabled: _ctx.isSubmit,
                      onClick: _ctx.postFromData
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("提交")
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_a_card, { key: 1 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_23, [
              (_ctx.isNum=='100')
                ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                    _createTextVNode("您尚未进行账号认证，请认证后再下单！点击“"),
                    _createElementVNode("a", {
                      onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.handleGotoCheck('check')))
                    }, "账号认证"),
                    _createTextVNode("”进行认证。")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isNum=='101')
                ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                    _createTextVNode("您尚未进行合同签署，请签署后再下单！点击“"),
                    _createElementVNode("a", {
                      onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.handleGotoCheck('check')))
                    }, "合同签署"),
                    _createTextVNode("”进行签署。")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isNum=='102')
                ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                    _createTextVNode("您的账户余额不足，无法下单，请点击“"),
                    _createElementVNode("a", {
                      onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.handleGotoCheck('rech')))
                    }, "充值"),
                    _createTextVNode("”。")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isNum=='103')
                ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                    _createTextVNode("您的账户存在逾期的账单，账户已冻结，请还款后再下单！点击“"),
                    _createElementVNode("a", {
                      onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.handleGotoCheck('rech')))
                    }, "充值"),
                    _createTextVNode("”进行还款。")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isNum=='104')
                ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                    _createTextVNode("您的账户已冻结，请充值后再下单！点击“"),
                    _createElementVNode("a", {
                      onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.handleGotoCheck('rech')))
                    }, "充值"),
                    _createTextVNode("”进行充值。")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isNum=='105')
                ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                    _createTextVNode("您的账户余额不足，请充值后再下单！点击“"),
                    _createElementVNode("a", {
                      onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.handleGotoCheck('rech')))
                    }, "充值"),
                    _createTextVNode("”进行充值。")
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })),
    _createVNode(_component_a_modal, {
      title: _ctx.title,
      width: "60%",
      visible: _ctx.visible,
      "onUpdate:visible": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.visible) = $event)),
      footer: null,
      maskClosable: false
    }, {
      default: _withCtx(() => [
        (_ctx.visible && (_ctx.typeStr == 'add' || _ctx.typeStr == 'Sender'))
          ? (_openBlock(), _createBlock(_component_Address, {
              key: 0,
              visible: _ctx.visible,
              "onUpdate:visible": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.visible) = $event)),
              typeStr: _ctx.typeStr,
              onFormData: _ctx.getLogistData
            }, null, 8, ["visible", "typeStr", "onFormData"]))
          : _createCommentVNode("", true),
        (_ctx.visible && _ctx.typeStr == 'addSku')
          ? (_openBlock(), _createBlock(_component_Addsku, {
              key: 1,
              visible: _ctx.visible,
              "onUpdate:visible": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.visible) = $event)),
              onSkuEmitData: _ctx.skuEmitData,
              typeStr: _ctx.typeStr,
              onIsAddSkuBtn: _ctx.getIsAddSkuBtn
            }, null, 8, ["visible", "onSkuEmitData", "typeStr", "onIsAddSkuBtn"]))
          : _createCommentVNode("", true),
        (_ctx.visible && _ctx.typeStr == 'addNewlyAddedSku')
          ? (_openBlock(), _createBlock(_component_NewlyAddedSku, {
              key: 2,
              visible: _ctx.visible,
              "onUpdate:visible": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.visible) = $event)),
              typeStr: _ctx.typeStr,
              onFormData: _ctx.getaddskuData
            }, null, 8, ["visible", "typeStr", "onFormData"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "visible"])
  ]))
}